<ng-container
  *ngTemplateOutlet="upcomingBuyingWindow ? noLink : link"
></ng-container>

<ng-template #link>
  <div class="programs-grid">
    @for (program of programs; track program) {
      <div class="programs-grid__item">
        @if (program.attr_is_featured > 0) {
          <span class="tag font-5">Featured</span>
        }
        <a
          class="programs-grid__item--image"
          routerLink="{{ program.programDetailsUrl }}"
        >
          @if (program.getImage()) {
            <img
              class="programs-grid__item__image"
              [src]="program.getImage().url"
              alt="Programs Image"
            />
          }
        </a>
        <div class="programs-grid__item--heading">
          <a
            routerLink="{{ program.programDetailsUrl }}"
            class="link full-width"
          >
            <span
              [innerHTML]="program.label | safeContent"
              class="programs-grid__item--label"
            ></span>
          </a>
        </div>
        <div class="programs-grid__item--meta">
          <strong class="programs-grid__item--meta-type">{{
            program.attr_program_type
          }}</strong>
          @if (program.id > 1 && !isODProgram(program)) {
            <div class="programs-grid__item--meta-dates">
              <span
                ><strong>In Market Date:</strong>
                {{ program.in_market_start_at | dateFormat }} -
                {{ program.in_market_end_at | dateFormat }}</span
              >
              <span
                ><strong>Ship Date:</strong> W/O,
                {{ program.ship_at | dateFormat }}</span
              >
            </div>
          }
        </div>
        @if (program.data && program.getContent()) {
          <p
            class="programs-grid__item--description font-5"
            [innerHTML]="program.description | truncate: 200 | safeContent"
          ></p>
        }
        <a
          class="link link-underline small uppercase"
          routerLink="{{ program.programDetailsUrl }}"
        >
          See More <i class="fal fa-angle-right"></i>
        </a>
        @if (program.brandGuideUrl != '') {
          <div class="programs-grid__item--action">
            <a target="_blank" href="{{ program.brandGuideUrl }}">
              <i class="fal fa-file-pdf"></i>
              <span>
                Brand
                <br />
                Activation Guide
              </span>
            </a>
            <a target="_blank" href="{{ program.brandGuideUrl }}">
              <span>Download</span>
              <i class="fal fa-arrow-to-bottom"></i>
            </a>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #noLink>
  <div class="programs-grid">
    @for (program of programs; track program) {
      <div class="programs-grid__item">
        @if (program.attr_is_featured > 0) {
          <span class="tag font-5">Featured</span>
        }
        <div class="programs-grid__item--image">
          @if (program.getImage()) {
            <img
              class="programs-grid__item__image"
              [src]="program.getImage().url"
              alt="Programs Image"
            />
          }
        </div>
        <div class="programs-grid__item--heading">
          <div class="link full-width">
            <span
              [innerHTML]="program.label | safeContent"
              class="programs-grid__item--label"
            ></span>
          </div>
        </div>
        <div class="programs-grid__item--meta">
          <strong class="programs-grid__item--meta-type">{{
            program.attr_program_type
          }}</strong>
          @if (program.id > 1 && !isODProgram(program)) {
            <div class="programs-grid__item--meta-dates">
              <span
                ><strong>In Market Date:</strong>
                {{ program.in_market_start_at | dateFormat }} -
                {{ program.in_market_end_at | dateFormat }}</span
              >
              <span
                ><strong>Ship Date:</strong> W/O,
                {{ program.ship_at | dateFormat }}</span
              >
            </div>
          }
        </div>
        @if (program.data && program.getContent()) {
          <p
            class="programs-grid__item--description font-5"
            [innerHTML]="program.description | truncate: 200 | safeContent"
          ></p>
        }
        @if (program.brandGuideUrl != '') {
          <div class="programs-grid__item--action">
            <a target="_blank" href="{{ program.brandGuideUrl }}">
              <i class="fal fa-file-pdf"></i>
              <span>
                Brand
                <br />
                Activation Guide
              </span>
            </a>
            <a target="_blank" href="{{ program.brandGuideUrl }}">
              <span>Download</span>
              <i class="fal fa-arrow-to-bottom"></i>
            </a>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
